import { PayloadAction } from "@reduxjs/toolkit";
import { UserState } from "../../models/UserState";
import { ResetPasswordPayload } from "../../payload/ResetPasswordPayload";

const resetPasswordFetch = (state: UserState, action: PayloadAction<ResetPasswordPayload>) => {
    state.isLoading = true;
}

export default resetPasswordFetch;